import React from 'react'

interface BlogPostProps {
  block: any;
  data: BlogPost;
}

const BlogPost: React.FC<BlogPostProps> = ({
  block,
  data,
}) => {
  return (
    <section className={`block ${block._template} ${block.css_class_name}`}>
      <div className="container container--blog-post">
        <div
          className="post__content"
          dangerouslySetInnerHTML={{ __html: data.html }}
        ></div>
      </div>
    </section>
  )
}

export default BlogPost
